import { atom } from "recoil";
import { IRefereeResponse } from "../interfaces/referee.interface";

export const referee = atom<IRefereeResponse | null>({
    key: "referee",
    default: null,
});